<div class="cpcontent">
    <h2>Beacon Logs</h2>
    <div class="row">
        <div class="col-md-4">
            <table class="table table-bordered">
                <thead>
                    <tr>
                        <th>Scenario Id</th>
                        <th>Scenario</th>
                        <th>Organization
                            <i class="bi bi-arrow-down-up"  style="font-size: 1.0em;" (click)="sortBy('organizationname')"></i>
                        </th>
                        <th>Last Date
                            <i class="bi bi-arrow-down-up"  style="font-size: 1.0em;" (click)="sortBy('lastDate')"></i>
                        </th>
                        <th>Count
                            <i class="bi bi-arrow-down-up"  style="font-size: 1.0em;" (click)="sortBy('count')"></i>
                        </th>
                        <th>Delete</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let o of overview">
                        <td class="link" (click)="getScenarioOverview(o.scenarioId)">{{o.scenarioId}}</td>
                        <td>{{lookup(o.scenarioId,scenarios)}}</td>
                        <td>{{o.organizationname}}</td>
                        <td>{{o.lastDate | date: 'shortDate'}}
                            
                        </td>
                        <td>{{o.count}}
                            
                        </td>
                        <td class="link" (click)="deleteByScenarioId(o)">Delete</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="col-md-4">
            <table *ngIf="showScenarioOverview" class="table table-bordered">
                <thead>
                    <tr>
                        <th>Phone Info</th>
                        <th>Count</th>
                        <th>Date</th>
                        <th>Download Select</th>
                        <th>Download Above</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let o of scenariooverview">
                        <td>{{o.phoneInfo}}</td>
                        <td>{{o.count}}</td>
                        <td>{{o.date | date: 'shortDate'}}</td>
                        <td class="link" (click)="downloadSelect(o)">download</td>
                        <td class="link" (click)="downloadAbove(o)">download</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <figure id="bar"></figure>
    <div *ngIf="showRecords">
        {{records.length}} records
        <button class="btn btn-primary" (click)="downloadFile(null)" style="float:right">Download</button>
        <br>
        <table class="table table-bordered">
            <thead>
                <tr>
                    <th>ScenarioId</th>
                    <th>PhoneInfo</th>
                    <th>BeaconName</th>
                    <th>DateCreated</th>
                    <th>Millis</th>
                    <th>Rssi</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let o of records">
                    <td>{{o.scenarioId}}</td>
                    <td class="link" (click)="graph(o.phoneInfo)">{{o.phoneInfo}}</td>
                    <td>{{o.beaconName}}</td>
                    <td>{{o.dateCreated | date: 'shortDate'}}</td>
                    <td>{{o.millis}}</td>
                    <td>{{o.rssi}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>